<template>
  <div class="grid px-25 py-8.5 bg-background-light gap-x-4 relative">
    <div class="flex items-center whitespace-nowrap">
      <slot />
    </div>
    <div v-if="variant === 'buttons'" class="flex items-center gap-x-8.5">
      <custom-button variant="text" @click="emit('cancel')">
        {{ $t("cancel") }}
      </custom-button>
      <custom-button variant="success" :busy="saving" @click="save">
        <slot name="submitText">
          {{ $t(saveKey) }}
        </slot>
      </custom-button>
    </div>
    <div v-if="variant === 'cross'" class="absolute right-9.5 top-1/2 -translate-y-1/2">
      <button class="flex justify-center items-center w-5 h-5" @click="emit('cancel')">
        <close-icon class="w-5 h-5 stroke-2" />
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import CustomButton from '@components/utils/CustomButton.vue';
import CloseIcon from '@images/close.svg?component';
import { onKeyStroke } from '@vueuse/core';

export type ModelHeaderVariant = 'buttons' | 'cross';

const props = withDefaults(defineProps<{ variant?: ModelHeaderVariant, saving?: boolean, saveKey?: string }>(), {
  variant: 'buttons' as ModelHeaderVariant,
  saveKey: 'save',
});

const emit = defineEmits(['cancel', 'submit']);

onKeyStroke('Escape', () => {
  emit('cancel');
});

const save = () => {
  if (!props.saving) {
    emit('submit');
  }
};
</script>

<style lang="scss" scoped>
.grid {
  grid-template-columns: 1fr auto;
}
</style>
